import React, { useContext } from 'react'
import AppContext from '../state/AppContext'
import { Divider, FormControl, InputLabel, MenuItem, Select, Tooltip } from '@mui/material';
import { Link, useNavigate } from 'react-router-dom';
import APIInvoke from '../utils/APIInvoke';
import SupervisedUserCircleIcon from '@mui/icons-material/SupervisedUserCircle';
import AddIcon from '@mui/icons-material/Add';
import SettingsIcon from '@mui/icons-material/Settings';
import ListItemText from '@mui/material/ListItemText';
import Checkbox from '@mui/material/Checkbox';
import StarBorderIcon from '@mui/icons-material/StarBorder';
import StarIcon from '@mui/icons-material/Star';
import UserContext from '../state/UserContext';
import GrantContent from './GrantContent';
import * as Permissions from '../utils/Permissions'
import LayersIcon from '@mui/icons-material/Layers';
import CrisisAlertIcon from '@mui/icons-material/CrisisAlert';
import FingerprintIcon from '@mui/icons-material/Fingerprint';
import NearbyErrorIcon from '@mui/icons-material/NearbyError';
import WebhookIcon from '@mui/icons-material/Webhook';
import RocketLaunchIcon from '@mui/icons-material/RocketLaunch';
import DashboardIcon from '@mui/icons-material/Dashboard';
import LocalPoliceIcon from '@mui/icons-material/LocalPolice';
import HomeIcon from '@mui/icons-material/Home';

const Aside = (props) => {

    const { appContext, setAppContext } = useContext(AppContext)
    const { user, setUser } = useContext(UserContext)
    const navigate = useNavigate()

    const changeProject = (e) => {
        const newProject = e.target.value
        if (newProject === "_new") {
            navigate(`/projects`)
        } else {
            const project = appContext.projects.find(p => p.name === newProject)
            setAppContext({ ...appContext, project: newProject, selectedProject: project })
            navigate(`/projects/${newProject}/dashboard`)
        }

    }

    const selectDefaultProject = async (event, project) => {
        event.stopPropagation()

        const request = {
            defaultProject: project.name
        }

        const response = await (await APIInvoke.invokePUT(`/users/settings`, request)).json()

        if (response.ok) {
            setUser({
                ...user,
                settings: {
                    ...user.settings,
                    defaultProject: project.name
                }
            })
        }

    }

    return (
        <aside id="aside" className="bg-dark-900 ">
            <div className="flex flex-col gap-8 bg-dark-900 h-full">
                <div className="flex px-4 border-b border-dark-400 h-16 p-4 items-center gap-2">
                    <Link to={`/projects/${appContext.project}`}>
                        <img src="/brand/goback-logo-white.png" alt="goback" className="h-10" />
                    </Link>
                </div>

                <div className="grid px-4">
                    <FormControl variant="outlined" size="small" className="">
                        <InputLabel htmlFor="project" >Select project</InputLabel>
                        <Select
                            id="project"
                            name="project"
                            label="project"
                            className="bg-dark-500 outline-red border border-dark-300"
                            value={appContext.project || ""}
                            onChange={changeProject}
                        >
                            <MenuItem disabled value=""><em>Select a project</em></MenuItem>
                            {appContext.projects.map(project => (
                                <MenuItem key={project.id} value={project.name}>
                                    <div className="flex items-center justify-between w-full">
                                        <ListItemText primary={project.name} />
                                        <Tooltip title="Set as default project">
                                            <Checkbox

                                                size="small"
                                                checked={user?.settings?.defaultProject === project.name}
                                                onClick={e => selectDefaultProject(e, project)}
                                                icon={<StarBorderIcon className="text-gray-200" />}
                                                checkedIcon={<StarIcon />}
                                            />
                                        </Tooltip>
                                    </div>
                                </MenuItem>

                            ))}
                            <GrantContent permisos={[Permissions.PROJECTS_C]} >
                                {(canAccess, roles, permisos, isPage) => (
                                    <Tooltip title={canAccess ? "New project" : `You don't have permission to create a new project, required permissions: ${permisos.join(", ")}`}>
                                        <span>
                                            <MenuItem disabled={!canAccess} onClick={() => navigate(`/projects`)} value="_new" className="text-green">
                                                <em className="text-green text-sm"><AddIcon fontSize="small" /> Nuevo</em>
                                            </MenuItem>
                                        </span>
                                    </Tooltip>
                                )}
                            </GrantContent>
                        </Select>
                    </FormControl>

                    <div className="flex gap-2 mt-2">
                        {appContext.selectedProject?.tags && appContext.selectedProject.tags.map(tag => <span key={tag.name} className={`text-${tag.color}-500 text-sm bg-dark-700 border !border-${tag.color}-500 rounded-md px-2 py-1 m-0 text-xs`}>{tag.name}</span>)}
                    </div>
                </div>

                <div className="grid gap-4 px-4">
                    <Link className="flex justify-start items-center gap-1" to={`/projects/${appContext.project}`} >
                        <HomeIcon className="text-green2-700" fontSize="small" />
                        <span className="capitalize text-gray-400 font-bold text-md">Home</span>
                    </Link>

                    <GrantContent permisos={[Permissions.DASHBOARD_R]}>
                        <Link className="flex justify-start items-center gap-1" to={`/projects/${appContext.project}/dashboard`} >
                            <DashboardIcon className="text-green2-700" fontSize="small" />
                            <span className="capitalize text-gray-400 font-bold text-md">Dashboard</span>
                        </Link>
                    </GrantContent>
                </div>


                <div className="grid gap-4 px-4">
                    <p className="text-gray-700 text-xs font-bold">DATA MANAGEMENT</p>
                    <GrantContent permisos={[Permissions.COLLECTIONS_R]}>
                        <Link className="flex justify-start items-center gap-1" to={`/projects/${appContext.project}/collections`} >
                            <LayersIcon className="text-green2-700" fontSize="small" />
                            <span className="capitalize text-gray-400 font-bold text-md">Collections</span>
                        </Link>
                    </GrantContent>
                    <GrantContent permisos={[Permissions.DOCUMENTS_R]}>
                        <Link className="flex justify-start items-center gap-1" to={`/projects/${appContext.project}/collections/notifications`} >
                            <CrisisAlertIcon className="text-green2-700" fontSize="small" />
                            <span className="capitalize text-gray-400 font-bold text-md">Collections Alerts</span>
                        </Link>
                    </GrantContent>

                    <GrantContent permisos={[Permissions.HIGH_FREQUENCY_ALERTS_R]}>
                        <Link className="flex justify-start items-center gap-1" to={`/projects/${appContext.project}/high-frequency-alerts`} >
                            <RocketLaunchIcon className="text-green2-700" fontSize="small" />
                            <span className="capitalize text-gray-400 font-bold text-md">High Frequency Monitor</span>
                        </Link>
                    </GrantContent>



                </div>

                <div className="grid gap-4 px-4">
                    <p className="text-gray-700 text-xs font-bold">AUDIT</p>
                    <GrantContent permisos={[Permissions.INCIDENTS_R]}>
                        <Link className="flex justify-start items-center gap-1" to={`/projects/${appContext.project}/incidents`} >
                            <NearbyErrorIcon className="text-green2-700" fontSize="small" />
                            <span className="capitalize text-gray-400 font-bold text-md">Incidents</span>
                        </Link>
                    </GrantContent>
                    <GrantContent permisos={[Permissions.AUDITLOGS_R]}>
                        <Link className="flex justify-start items-center gap-1" to={`/projects/${appContext.project}/auditlogs`} >
                            <FingerprintIcon className="text-green2-700" fontSize="small" />
                            <span className="capitalize text-gray-400 font-bold text-md">Audit Logs</span>
                        </Link>
                    </GrantContent>
                </div>


                {/*<div className="grid gap-4 px-4">
                    <p className="text-gray-700 text-sm font-bold">MONITORING</p>
                    <GrantContent permisos={[Permissions.APP_MONITORING_R]}>
                        <Link className="flex justify-start items-center gap-1" to={`/projects/${appContext.project}/monitoring/apps`} >
                            <MonitorHeartIcon className="text-green2-700" fontSize="small" />
                            <span className="capitalize text-gray-400 font-bold text-md">App Monitoring</span>
                        </Link>
                    </GrantContent>
                </div>*/}

                {/*<div className="grid gap-4 px-4">
                    <p className="text-gray-700 text-sm font-bold">OBSERVABILITY</p>
                    <GrantContent permisos={[Permissions.APP_MONITORING_R]}>
                        <Link className="flex justify-start items-center gap-1" to={`/projects/${appContext.project}/monitoring/apps`} >
                            <GrainIcon className="text-green2-700" fontSize="small" />
                            <span className="capitalize text-gray-400 font-bold text-md">Transactional logs</span>
                        </Link>
                    </GrantContent>
                </div>*/}



                <div className="grid gap-4 px-4">
                    <p className="text-gray-700 text-xs font-bold">ADMINISTRATION</p>
                    <GrantContent permisos={[Permissions.USERS_R]}>
                        <Link className="flex justify-start items-center gap-1" to={`/users`} >
                            <SupervisedUserCircleIcon className="text-green2-700" fontSize="small" />
                            <span className="capitalize text-gray-400 font-bold text-md">Users</span>
                        </Link>
                    </GrantContent>


                    {/*<GrantContent permisos={[Permissions.CONFIG_PROPERTIES_R]}>
                        <Link className="flex justify-start items-center gap-1" to={`/projects/${appContext.project}/config-properties`} >
                            <PinIcon className="text-green2-700" fontSize="small" />
                            <span className="capitalize text-gray-400 font-bold text-md">Config Properties</span>
                        </Link>
                    </GrantContent>*/}

                    <GrantContent permisos={[Permissions.WEBHOOKS_R]}>
                        <Link className="flex justify-start items-center gap-1" to={`/projects/${appContext.project}/webhooks`} >
                            <WebhookIcon className="text-green2-700" fontSize="small" />
                            <span className="capitalize text-gray-400 font-bold text-md">Webhooks</span>
                        </Link>
                    </GrantContent>


                    <GrantContent permisos={[Permissions.SECRETS_R]}>
                        <Link className="flex justify-start items-center gap-1" to={`/projects/${appContext.project}/secrets`} >
                            <LocalPoliceIcon className="text-green2-700" fontSize="small" />
                            <span className="capitalize text-gray-400 font-bold text-md">Secrets</span>
                        </Link>
                    </GrantContent>

                    <GrantContent permisos={[Permissions.PROJECTS_W]}>
                        <Link className="flex justify-start items-center gap-1" to={`/projects/${appContext.project}/edit`} >
                            <SettingsIcon className="text-green2-700" fontSize="small" />
                            <span className="capitalize text-gray-400 font-bold text-md">Project settings</span>
                        </Link>
                    </GrantContent>
                </div>
            </div>
        </aside>
    )

}

export default Aside;